// 获取所有分值选项
export function getAllScores() {
  return [
    "45",
    "40",
    "68",
    "67+",
    "67",
    "66+",
    "66",
    "65+",
    "65",
    "64+",
    "64",
    "63+",
    "63",
    "62+",
    "62",
    "61+",
    "61",
    "60",
    "58+",
    "58",
    "55",
    "53",
    "50",
    "35",
    "30",
    "91",
    "92",
    "93",
    "94",
    "95",
    "97",
    "98",
    "UNC92",
    "UNC97",
    "UNC98",
    "sp40",
    "sp45",
    "sp50",
    "sp53",
    "sp55",
    "sp58",
    "sp58+",
    "sp60",
    "sp60+",
    "sp61",
    "sp61+",
    "sp62",
    "sp62+",
    "sp63",
    "sp63+",
    "sp64",
    "sp64+",
    "sp65",
    "sp65+",
    "sp66",
    "sp66+",
    "sp67",
    "sp67+",
    "sp68"
  ];
}